// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"19e37ce0","580":"4c895290","971":"10b4385f"}[chunkId] + ".chunk.js";
};